export default "__VITE_ASSET__CXK98bHL__"